
require("./forms/limit_file_size_for_file_input");
require("./forms/cal_to_datepicker");
